import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstanceV2 from '../../Apis/AxiosV2';
import {FILE_UPLOAD_SERVICE} from "../EndPoints";

export const DownloadDataZip = (data, nameZip) => {
    const blob = new Blob([data], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${nameZip}.zip`);
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export const ZipDownload = createAsyncThunk(
    'fileUpload/zipDownload',
    async (params) => {
        const result = await apiInstanceV2
            .post(`${FILE_UPLOAD_SERVICE.zipDownload}`, params, { responseType: 'blob' } )
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ZipDownloadByUserId = createAsyncThunk(
    'fileUpload/zipDownloadByUserId',
    async (userId) => {
        try {
            const url = `${FILE_UPLOAD_SERVICE.zipDownloadByUserId}${userId}`;

            const response = await apiInstanceV2.post(url, null, {
                responseType: 'blob'
            });

            return { data: response.data, status: response.status };
        } catch (error) {
            return { data: null, status: error.response?.status };
        }
    }
);

export const DeleteFileById = createAsyncThunk(
    'fileUpload/deleteById',
    async (params) => {
        const result = await apiInstanceV2
            .delete(`${FILE_UPLOAD_SERVICE.baseV1}${params}` )
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

